module.exports = __webpack_public_path__ + "static/media/AdobeSongStd-Light-Alphabetic-01.61cc144b.svg";